import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
// import { parseDate } from '@internationalized/date';
const initialState = {
  priseEnChargeClinique: 3,
  priseEnChargeData: {},
  priseEnChargeDataBloc: {},
  priseEnChargeDataAllRows: [],
  priseEnChargeDataAllRowsBloc: [],
  GlobalMonth: moment().format("MM"),
  GlobalYear: moment().format("YYYY"),
  GlobalCheckBoxValEnCo: 0,
  GlobalCheckBoxValEnCoBloc: 0,
  date: { start: (moment().format("YYYY-MM-DD")), end: (moment().format("YYYY-MM-DD")) },
  mutualiste: 3,
  opere: 0,
  FK_id_medecin2: 3
};

export const PriseEnChargeSlice = createSlice({
  name: "PriseEnCharge",
  initialState,
  reducers: {
    OnePriseEnChargeDATA: (state, action) => {
      state.priseEnChargeData = action.payload;
    },
    PriseEnChargeDATAllRows: (state, action) => {
      state.priseEnChargeDataAllRows = action.payload;
    },

    PriseEnChargeDATAllRowsBloc: (state, action) => {
      state.priseEnChargeDataAllRowsBloc = action.payload;
    },
    PriseEnChargeMonth: (state, action) => {
      state.GlobalMonth = action.payload;
    },
    PriseEnChargeYear: (state, action) => {
      state.GlobalYear = action.payload;
    },
    GlobalCheckBoxValideEnCours: (state, action) => {
      state.GlobalCheckBoxValEnCo = action.payload;
    },
    GlobalCheckBoxValideEnCoursBloc: (state, action) => {
      state.GlobalCheckBoxValEnCoBloc = action.payload;
    },
    GlobalDATEBloc1: (state, action) => {
      state.date = action.payload;
    },
    GlobalSelectClinique: (state, action) => {
      state.priseEnChargeClinique = action.payload;
    },
    GlobalSelectmutualiste: (state, action) => {
      state.mutualiste = action.payload;
    },
    GlobalSelectOpere: (state, action) => {
      state.opere = action.payload;
    },
    GlobalSelectMedecin: (state, action) => {
      state.FK_id_medecin2 = action.payload;
    },
  },
});

export const {
  GlobalSelectMedecin,
  PriseEnChargeDATAllRowsBloc,
  OnePriseEnChargeDATA,
  PriseEnChargeDATAllRows,
  PriseEnChargeYear,
  PriseEnChargeMonth,
  GlobalCheckBoxValideEnCours,
  GlobalCheckBoxValideEnCoursBloc,
  GlobalDATEBloc1,
  GlobalDATEBloc2,
  GlobalSelectClinique,
  GlobalSelectmutualiste,
  GlobalSelectOpere
} = PriseEnChargeSlice.actions;

export const selectPriseEnChargeGrid = (state) => state.PriseEnCharge;

export default PriseEnChargeSlice.reducer;
